// Copied verbatim from konradwalz.com/agb-s-cookies-y.
// A string is a paragraph; a string[] is a bullet list.
export type LegalBlock = string | string[];

export type LegalSection = {
  heading?: string;
  blocks: LegalBlock[];
};

export type LegalDownload = {
  title: string;
  description: string;
  format: string;
  /** File URL. Empty until the real document is uploaded — the button then shows "auf Anfrage". */
  url: string;
};

export type LegalPage = {
  slug: string;
  label: string;
  title: string;
  sections: LegalSection[];
  downloads?: LegalDownload[];
};

export const legalPages: LegalPage[] = [
  {
    slug: 'impressum',
    label: 'Impressum',
    title: 'Impressum',
    sections: [
      {
        heading: 'Angaben gemäß § 5 DDG',
        blocks: [
          'Konrad Walz Einzelunternehmer',
          'Klingenstraße 5\n73491 Neuler\nDeutschland',
          'Telefon: +49 157 73491110\nE-Mail: konrad.walz@icloud.com',
        ],
      },
      { heading: 'Vertreten durch', blocks: ['Konrad Walz'] },
      {
        heading: 'Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV',
        blocks: ['Konrad Walz\nKlingenstraße 5\n73491 Neuler\nDeutschland'],
      },
      {
        heading: 'Haftung für Inhalte',
        blocks: [
          'Als Diensteanbieter bin ich gemäß den gesetzlichen Vorschriften für eigene Inhalte verantwortlich.',
          'Eine Verpflichtung zur dauerhaften Überwachung übermittelter oder gespeicherter fremder Informationen besteht jedoch nicht.',
          'Bei Bekanntwerden von Rechtsverletzungen werden entsprechende Inhalte unverzüglich entfernt.',
        ],
      },
      {
        heading: 'Haftung für externe Links',
        blocks: [
          'Diese Website enthält Verlinkungen auf externe Webseiten Dritter.',
          'Auf deren Inhalte habe ich keinen Einfluss.',
          'Für die Inhalte der verlinkten Seiten sind ausschließlich deren jeweilige Betreiber verantwortlich.',
          'Eine permanente Kontrolle der verlinkten Seiten ist ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar.',
        ],
      },
      {
        heading: 'Urheberrecht',
        blocks: [
          'Alle auf dieser Website veröffentlichten Inhalte, insbesondere',
          [
            'Texte',
            'Bilder',
            'Grafiken',
            'Logos',
            'Zeichnungen',
            'CAD-Darstellungen',
            'technische Visualisierungen',
            'Animationen',
            'Designs',
          ],
          'unterliegen dem deutschen Urheberrecht sowie gegebenenfalls weiteren Schutzrechten.',
          'Jede Vervielfältigung, Bearbeitung, Verbreitung oder sonstige Nutzung außerhalb der gesetzlichen Grenzen des Urheberrechts bedarf der vorherigen schriftlichen Zustimmung des jeweiligen Rechteinhabers.',
          'Soweit Inhalte dieser Website nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet.',
        ],
      },
    ],
  },
  {
    slug: 'datenschutz',
    label: 'Datenschutz',
    title: 'Datenschutzerklärung',
    sections: [
      {
        heading: '1. Allgemeine Hinweise',
        blocks: [
          'Der Schutz Ihrer personenbezogenen Daten ist mir ein wichtiges Anliegen. Personenbezogene Daten werden ausschließlich im Rahmen der gesetzlichen Datenschutzvorschriften, insbesondere der Datenschutz-Grundverordnung (DSGVO) sowie des Bundesdatenschutzgesetzes (BDSG), verarbeitet.',
          'Diese Datenschutzerklärung informiert Sie darüber, welche Daten beim Besuch dieser Website erhoben werden und zu welchem Zweck diese verarbeitet werden.',
        ],
      },
      {
        heading: '2. Verantwortlicher',
        blocks: [
          'Verantwortlicher im Sinne der DSGVO ist:',
          'Konrad Walz\nKlingenstraße 5\n73491 Neuler\nDeutschland',
          'E-Mail: konrad.walz@icloud.com\nTelefon: +49 157 73491110',
        ],
      },
      {
        heading: '3. Hosting',
        blocks: [
          'Diese Website wird über Wix.com Ltd. bereitgestellt.',
          'Beim Aufruf der Website werden automatisch Informationen verarbeitet, unter anderem:',
          [
            'IP-Adresse',
            'Datum und Uhrzeit des Zugriffs',
            'Browsertyp',
            'Betriebssystem',
            'Referrer-URL',
            'aufgerufene Seiten',
            'technische Serverinformationen',
          ],
          'Diese Daten dienen ausschließlich dem sicheren und störungsfreien Betrieb der Website.',
          'Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse).',
          'Weitere Informationen finden Sie in den Datenschutzbestimmungen von Wix.',
        ],
      },
      {
        heading: '4. Kontaktaufnahme',
        blocks: [
          'Wenn Sie mich per Kontaktformular oder E-Mail kontaktieren, werden Ihre Angaben ausschließlich zur Bearbeitung Ihrer Anfrage gespeichert und verarbeitet.',
          'Dies betrifft beispielsweise:',
          ['Name', 'E-Mail-Adresse', 'Telefonnummer (falls angegeben)', 'Nachrichteninhalt'],
          'Die Daten werden nicht an Dritte weitergegeben, sofern keine gesetzliche Verpflichtung besteht.',
          'Rechtsgrundlage:\nArt. 6 Abs. 1 lit. b DSGVO (Vertragsanbahnung)\nbzw.\nArt. 6 Abs. 1 lit. f DSGVO.',
        ],
      },
      {
        heading: '5. Cookies',
        blocks: [
          'Diese Website verwendet Cookies.',
          'Technisch notwendige Cookies sind erforderlich, damit die Website ordnungsgemäß funktioniert.',
          'Sollten Analyse-, Statistik- oder Marketing-Cookies verwendet werden, erfolgt deren Speicherung ausschließlich nach Ihrer ausdrücklichen Einwilligung über das Cookie-Banner.',
          'Sie können Ihre Einwilligung jederzeit widerrufen.',
        ],
      },
      {
        heading: '6. Speicherdauer',
        blocks: [
          'Personenbezogene Daten werden nur so lange gespeichert, wie dies zur Erfüllung des jeweiligen Zwecks erforderlich ist oder gesetzliche Aufbewahrungspflichten bestehen.',
        ],
      },
      {
        heading: '7. Ihre Rechte',
        blocks: [
          'Sie haben jederzeit das Recht auf',
          [
            'Auskunft',
            'Berichtigung',
            'Löschung',
            'Einschränkung der Verarbeitung',
            'Datenübertragbarkeit',
            'Widerruf einer Einwilligung',
            'Widerspruch gegen die Verarbeitung',
            'Beschwerde bei einer Datenschutzaufsichtsbehörde.',
          ],
        ],
      },
      {
        heading: '8. SSL- bzw. TLS-Verschlüsselung',
        blocks: [
          'Diese Website nutzt aus Sicherheitsgründen eine SSL-/TLS-Verschlüsselung. Dadurch werden übermittelte Daten verschlüsselt übertragen.',
        ],
      },
      {
        heading: '9. Änderungen dieser Datenschutzerklärung',
        blocks: [
          'Ich behalte mir vor, diese Datenschutzerklärung anzupassen, sofern gesetzliche Änderungen oder technische Entwicklungen dies erforderlich machen.',
        ],
      },
    ],
  },
  {
    slug: 'cookies',
    label: 'Cookie-Richtlinie',
    title: 'Cookie-Richtlinie',
    sections: [
      {
        blocks: [
          'Diese Website verwendet Cookies.',
          'Cookies sind kleine Textdateien, die auf Ihrem Endgerät gespeichert werden und bestimmte Funktionen der Website ermöglichen.',
          'Es werden folgende Arten von Cookies verwendet:',
        ],
      },
      {
        heading: 'Technisch notwendige Cookies',
        blocks: ['Diese Cookies sind für den Betrieb der Website erforderlich und können nicht deaktiviert werden.'],
      },
      {
        heading: 'Analyse-Cookies',
        blocks: [
          'Analyse-Cookies helfen dabei, die Nutzung der Website zu verstehen und zu verbessern. Sie werden nur mit Ihrer Einwilligung gesetzt.',
        ],
      },
      {
        heading: 'Marketing-Cookies',
        blocks: [
          'Marketing-Cookies dienen dazu, Inhalte und Werbung zu personalisieren. Auch diese werden ausschließlich nach Ihrer Einwilligung verwendet.',
          'Sie können Ihre Cookie-Einstellungen jederzeit über das Cookie-Banner ändern oder widerrufen.',
        ],
      },
    ],
  },
  {
    slug: 'agb',
    label: 'AGB',
    title: 'Allgemeine Nutzungsbedingungen',
    sections: [
      {
        heading: 'Geltungsbereich',
        blocks: ['Diese Website dient ausschließlich der allgemeinen Information über die angebotenen Dienstleistungen.'],
      },
      {
        heading: 'Inhalte',
        blocks: [
          'Alle Inhalte wurden mit größtmöglicher Sorgfalt erstellt.',
          'Eine Gewähr für',
          ['Aktualität', 'Vollständigkeit', 'Richtigkeit', 'Fehlerfreiheit'],
          'kann jedoch nicht übernommen werden.',
        ],
      },
      {
        heading: 'Nutzung',
        blocks: [
          'Die Nutzung der bereitgestellten Informationen erfolgt auf eigene Verantwortung.',
          'Ein Anspruch auf bestimmte Leistungen ergibt sich aus den Informationen dieser Website nicht.',
        ],
      },
    ],
  },
  {
    slug: 'b2b-downloadbereich',
    label: 'B2B-Downloadbereich',
    title: 'B2B-Downloadbereich',
    sections: [
      {
        blocks: [
          'Alle wichtigen Unterlagen für Einkauf, Lieferantenfreigabe und Projektstart an einem Ort. Laden Sie die Dokumente direkt herunter oder fordern Sie sie per E-Mail an.',
          'Vor dem Austausch von Konstruktionsdaten unterzeichnen wir eine Geheimhaltungsvereinbarung (NDA). Der Datenaustausch erfolgt anschließend sicher über diesen geschützten B2B-Bereich.',
        ],
      },
    ],
    downloads: [
      {
        title: 'Gewerbeanmeldung',
        description: 'Nachweis der angemeldeten gewerblichen Tätigkeit – für Ihre Lieferantenfreigabe.',
        format: 'PDF',
        url: '',
      },
      {
        title: 'Firmenprofil',
        description: 'Leistungen, Software, Branchen und Referenzen auf einen Blick.',
        format: 'PDF',
        url: '',
      },
      {
        title: 'NDA-Patentformular',
        description: 'Geheimhaltungsvereinbarung zum Ausfüllen und Unterzeichnen vor Projektbeginn.',
        format: 'PDF',
        url: '',
      },
      {
        title: 'IHK-Zertifikat',
        description: 'Nachweis der fachlichen Qualifikation.',
        format: 'PDF',
        url: '',
      },
    ],
  },
  {
    slug: 'b2b-sicherheit',
    label: 'B2B-Sicherheit',
    title: 'B2B-Sicherheit',
    sections: [
      {
        heading: 'Rechtssicherheit & Haftungsübernahme',
        blocks: [
          'Alle Konstruktions- und Entwicklungsdienstleistungen der NMW Studios sind über eine branchenspezifische Betriebshaftpflicht- und Vermögensschadenversicherung mit einer Deckungssumme von bis zu 5 Millionen Euro vollumfänglich abgesichert.',
          'Bei Fehlern in der Auslegung tragen Sie als Kunde null unternehmerisches Risiko.',
        ],
      },
      {
        heading: 'Ausfallsicherheit (Kein Ein-Mann-Risiko)',
        blocks: [
          'Während klassische Freelancer bei Krankheit oder Urlaub Ihr Projekt blockieren, bietet die NMW Studios GmbH durch ein etabliertes, internationales Konstruktionsnetzwerk absolute Liefergarantie. Wir steuern CAD-Kapazitäten flexibel im Hintergrund, sodass Ihre Deadlines und Serienanläufe zu 100 % gehalten werden.',
        ],
      },
      {
        heading: 'IT-Infrastruktur & IP-Datenschutz',
        blocks: [
          'Ihre Erfindungen und Patente sind bei uns absolut sicher. Der Datentransfer erfolgt ausschließlich über AES-256-bit-verschlüsselte Cloud-Server und hardwareverschlüsselte Workstations nach strengen DSGVO-Richtlinien. Ein Datenaustausch oder die Freigabe von Projektordnern erfolgt grundsätzlich erst nach Unterzeichnung eines wechselseitigen B2B-NDAs (Geheimhaltungsvereinbarung).',
        ],
      },
      {
        heading: 'Qualitätsmanagement nach ISO 9001',
        blocks: [
          'Um Fehler bei der Auslagerung an unser Netzwerk komplett auszuschließen, sind all unsere Prozesse und die finale, deutsche Endkontrolle aller CAD-Daten streng nach den Qualitätsmanagement-Richtlinien der ISO 9001 ausgerichtet. Jedes Modell durchläuft eine strikte Toleranz- und Passungsprüfung, bevor es an Sie übergeben wird.',
        ],
      },
    ],
  },
];
